export default "__VITE_ASSET__UPrMa8HM__"